
import AffirmationFilterModel from "@models/affirmations/affirmationFilterModel";
import { Vue, Component, Inject } from "vue-property-decorator";
import { AFFIRMATION_CREATE, AFFIRMATION_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import AffirmationGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationGetListResponse";
import { DragLiModel } from "@components/ui/models";
import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import PaginationRequest from "@/api/dataSource/api/Common/RequestModels/PaginationRequest";
import TranslationItemModel from "@models/translationItemModel";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";

@Component
export default class PageAffirmationComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: AffirmationFilterModel = new AffirmationFilterModel();
  columnNames = ["#", "Картинка", "Название", "Платная", "Дата", "", ""];
  createRouteName = AFFIRMATION_CREATE;
  editRouteName = AFFIRMATION_EDIT;
  get getDataFunc() {
    return this.$api.AffirmationService.getListAsync.bind(this.$api.AffirmationService);
  }
  get removeFunc() {
    return this.$api.AffirmationService.deleteAsync.bind(this.$api.AffirmationService);
  }

  async created() {}

  async startDelete(item: AffirmationGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    const pageSize = 100;
    const items: AffirmationGetListResponse[] = [];
    let skip = 0;
    let total = 0;

    do {
      const request = new SearchFilterRequest({
        Name: "",
        Pagination: new PaginationRequest({
          Skip: skip,
          Take: pageSize,
        }),
      });

      const response = await self.$api.AffirmationService.getListAsync(request);
      items.push(...(response.Items || []));
      total = response.Count || items.length;
      skip += pageSize;
    } while (items.length < total);

    if (!items.length) {
      return null;
    }

    return items
      .slice()
      .sort((a, b) => {
        const aSortIndex = Number(a.SortIndex);
        const bSortIndex = Number(b.SortIndex);
        const aHasSortIndex = aSortIndex > 0;
        const bHasSortIndex = bSortIndex > 0;

        if (aHasSortIndex && bHasSortIndex) {
          return aSortIndex - bSortIndex;
        }
        if (aHasSortIndex) return -1;
        if (bHasSortIndex) return 1;
        return 0;
      })
      .map(
        (x, index) =>
          new DragLiModel({
            Id: x.Id,
            Image: x.CoverUrl,
            SortIndex:
              Number(x.SortIndex) > 0 ? Number(x.SortIndex) : index + 1,
            Translate: (x.Translations || []).map(
              (t) =>
                new TranslationItemModel({
                  langCode: t.LangCode,
                  name: t.Name,
                })
            ),
          })
      );
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    const result = await this.$api.AffirmationService.changeSortIndexAsync(
      new ChangeSortIndexRequest({
        SortIndices: items.map(
          (item, index) =>
            new SortIndexRequest({
              Id: Number(item.Id),
              SortIndex: index + 1,
            })
        ),
      })
    );

    if (!result) {
      throw new Error("Не удалось сохранить порядок аффирмаций.");
    }

    this.$notification.success("Порядок успешно изменен.");
    return true;
  }
}
